import {faFile} from '@fortawesome/pro-regular-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Flex} from 'antd';
import {ReactElement} from 'react';

import * as styles from './knowledge-files-list.scss';

type FileType = {
    url: string;
    name: string;
};

type PropsType = {
    files: Array<FileType>;
};

export function KnowledgeFilesList(props: PropsType): ReactElement {
    const {files} = props;

    return (
        <Flex className={styles.KnowledgeFilesList} vertical>
            {files.map((file) => (
                <a download={file.name} href={file.url} key={file.url} type="text">
                    <FontAwesomeIcon icon={faFile} /> {file.name}
                </a>
            ))}
        </Flex>
    );
}
